import React, { useState } from "react";
import ApiService from "../Services/user/service";
import { toast } from "react-toastify";
import  {  useRef } from "react";

const DocumentModal = ({ show, onClose }) => {
  const [preview, setPreview] = useState(null);
  const [documentType, setDocumentType] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

const fileInputRef = useRef(null);
  if (!show) return null;

  const resetForm = () => {
  setDocumentType("");
  setFile(null);
  setPreview(null);
  
  if (fileInputRef.current) {
    fileInputRef.current.value = ""; // ✅ REAL RESET
  }
};


  // FILE → BASE64
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        const base64 = reader.result.split(",")[1]; 
        resolve(base64);
      };

      reader.onerror = (error) => reject(error);
    });
  };

  // FILE CHANGE
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
    }
  };

  // START KYC API CALL
  const handleStartKyc = async () => {
    if (!documentType) {
      toast("Please select document type");
      return;
    }

    if (!file) {
      toast("Please upload document");
      return;
    }

    try {
      setLoading(true);

      const base64Image = await fileToBase64(file);
      const userId = localStorage.getItem("user_id");

      const payload = {
        userId: userId,
        title: documentType,
        image: base64Image,
      };

      const res = await ApiService.updateUserDocument(payload);

      if (res?.data?.success === true) {
        toast("KYC Started Successfully");
          resetForm();  
        onClose();
      } else {
        toast(res?.data?.message || "Something went wrong");
      }
    } catch (error) {
      console.error(error);
      toast("Server Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0,0,0,0.6)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content rounded-4">

          {/* HEADER */}
          <div className="modal-header">
            <h5 className="modal-title">
              KYC Status :
              <span className="text-danger ms-2">Incomplete</span>
            </h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          {/* BODY */}
          <div className="modal-body overflow-y-auto">
            <p className="text-muted mb-3">
              Your KYC submission is incomplete.
              Please provide missing documents.
            </p>

            {/* DOCUMENT TYPE */}
            <div className="mb-3">
              <label className="form-label">Document Type</label>
              <select
                className="form-select"
                value={documentType}
                onChange={(e) => setDocumentType(e.target.value)}
              >
                <option value="">Select document</option>
                <option value="PAN">PAN Card</option>
                <option value="AADHAAR">Aadhaar Card</option>
                <option value="VOTER">Voter ID</option>
                <option value="PASSPORT">Passport</option>
                <option value="DL">Driving License</option>
                <option value="OTHER">Other</option>
              </select>
            </div>

            {/* FILE UPLOAD */}
            <div className="mb-3">
              <label className="form-label">Upload Document</label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                  ref={fileInputRef}
                onChange={handleFileChange}
              />
            </div>

            {/* IMAGE PREVIEW */}
            {preview && (
              <div className="mt-3">
                <img
                  src={preview}
                  alt="Document Preview"
                  className="img-fluid rounded border"
                  style={{ maxHeight: "100px" }}
                />
              </div>
            )}
          </div>

          {/* FOOTER */}
          <div className="modal-footer">
          <button
  className="btn btn-secondary"
  onClick={() => {
    resetForm();
    onClose();
  }}
>
  Cancel
</button>


            <button
              className="btn btn-primary"
              onClick={handleStartKyc}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Start KYC"}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default DocumentModal;
